import React, { FormEvent } from "react";
import { FieldValues, Path, PathValue, RegisterOptions, UseFormSetValue, UseFormWatch } from "react-hook-form";
import { SelectOption } from "./StyledSelectInput";
import clsx from "clsx";
import { on } from "events";

export interface RadioSelectOption extends SelectOption {
  disabled?: boolean;
}

interface StyledRadioButtonGroupInputProps<T extends FieldValues> extends Omit<React.HTMLProps<HTMLInputElement>, "onChange"> {
  registerName: Path<T>;
  setValue: UseFormSetValue<T>;
  watch: UseFormWatch<T>;
  options: RadioSelectOption[];
  label?: string;
  registerOptions?: RegisterOptions<T, Path<T>>;
  classes?: string;
  onChange?: (v: string) => void;
}


export function StyledRadioButtonGroupInput<T extends FieldValues>({
  registerName,
  setValue,
  watch,
  options,
  classes,
  label,
  onChange
}: StyledRadioButtonGroupInputProps<T>) {
  const currentValue = watch(registerName);

  return <div className="flex flex-col">
    {label && <label className="text-sm mb-1 font-medium text-gray-700">{label}</label>}
    <div className="flex items-end">
      {options.map((option, i) => (
        <div className={clsx(
          "border-t border-b border-r border-etpink-600 text-sm font-medium px-3 py-2",
          i === 0 && "rounded-l-lg border-l",
          i === options.length - 1 && "rounded-r-lg",
          currentValue === option.value ? "bg-etpink-600 text-white" : "bg-white text-gray-800",
          option.disabled && "bg-gray-200 text-gray-600",
          classes
        )}
          key={option.value}
          onClick={
            option.disabled ?
              () => { }
              : () => {
                setValue(registerName, option.value as unknown as PathValue<T, Path<T>>, { shouldDirty: true })
                onChange && onChange(option.value)
              }
          }
        >
          {option.label}
        </div>
      ))}
    </div>
  </div>
}